import React from 'react'
import V2Layout from '../../components/V2Layout'
import SEO from '../../components/SEO'
import CapabilityPageNav from './CapabilityPageNav'
import CapabilitySections from './CapabilitySections'
import '../../versions/v2/capabilities.css'

const AssemblyTestPage = () => (
    <V2Layout pageClass="pfc-capabilities">
        <SEO
            title="Assembly & Test"
            description="Multiple dedicated assembly cells in a controlled clean work area, with cryogenic test capability and life cycle validation to thousands of cycles."
        />
        <section className="pfc-page-hero">
            <div className="pfc-page-hero-inner">
                <p className="v2-section-label">Our Capabilities · 04</p>
                <h1 className="pfc-page-hero-title">Assembly &amp; Test</h1>
                <p className="pfc-page-hero-sub">
                    Multiple dedicated assembly cells in a controlled clean work area, with cryogenic test capability and life cycle validation to thousands of cycles.
                </p>
            </div>
        </section>

        

        <CapabilitySections slug="assembly-test" />

        <CapabilityPageNav currentSlug="assembly-test" />
    </V2Layout>
)

export default AssemblyTestPage
